import React from 'react';
import { FormNewContainer } from '../../components/forms/FormNewContainer';

const FormNewPage: React.FC = () => {
  return <FormNewContainer />;
};

export default FormNewPage;
